import { useEffect } from "react";
import { usePublicSettings } from "@/features/catalog/hooks";

/**
 * Public settings'ten alınan favicon URL'ini runtime'da
 * <link rel="icon"> tag'ine uygular. Setting boşsa default favicon kalır.
 */
export function useApplyFavicon() {
  const { data } = usePublicSettings();
  const apiBase = import.meta.env.VITE_API_URL || "";

  useEffect(() => {
    const url = data?.site_favicon_url;
    if (!url) return;

    const href = url.startsWith("http") ? url : `${apiBase}${url}`;
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    // Tarayıcı svg/png/ico hangisiyse otomatik algılar; type ipucu opsiyonel.
    link.setAttribute("href", href);
    // .ico, .png, .svg ayrımı
    if (url.endsWith(".svg")) link.setAttribute("type", "image/svg+xml");
    else if (url.endsWith(".png")) link.setAttribute("type", "image/png");
    else if (url.endsWith(".ico")) link.setAttribute("type", "image/x-icon");
  }, [data?.site_favicon_url, apiBase]);
}
